import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FileText, ChevronRight, Loader2 } from "lucide-react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { useAppDispatch } from "../../../redux/store";
import { getThisWeekTimeCardSummary } from "../../../redux/features/EmployeeTimeCard";
import { useNavigationHistory } from "../../../hooks/useNavigationHistory";

const WebTimesheetSummaryTile: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { thisWeekSummary, loading } = useSelector(
        (state: RootState) => state.employeeTimeCardData
    );
    const user = useSelector((state: RootState) => state.user.user);
    const { setSourcePath } = useNavigationHistory();

    useEffect(() => {
        if (user?.os_emp_account_id) {
            dispatch(getThisWeekTimeCardSummary({ 
                employee_id: Number(user.os_emp_account_id), 
                forceRefresh: true 
            }));
        }
    }, [dispatch, user?.os_emp_account_id]);

    const handleNavigate = () => {
        setSourcePath("/web-dashboard");
        navigate("/m-timesheet", { state: { from: "/web-dashboard" } });
    };

    return (
        <div className="p-6 h-full cursor-pointer" onClick={handleNavigate}>
            <div className="flex items-center justify-between mb-4">
                <h2 className="text-lg text-blue-600 leading-tight hover:text-blue-600 transition-colors">
                    My Timesheet
                </h2>
                <FileText className="w-5 h-5 flex-shrink-0 text-gray-400" />
            </div>

            <div className="flex-1 flex flex-col items-center justify-center">
                {loading ? (
                    <div className="flex justify-center py-8">
                        <Loader2 className="w-6 h-6 animate-spin text-blue-600" />
                    </div>
                ) : (
                    <div className="text-center">
                        <div className="text-2xl text-gray-700 mb-2">
                            {thisWeekSummary?.total_hours || "0.00"}
                        </div>
                        <div className="text-sm text-gray-600">
                            Hours This Week
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default WebTimesheetSummaryTile; 